"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import {
  SCHEDULE_FILTER_APPLIED,
  SCHEDULE_SORT_APPLIED,
} from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useScheduledGamesFilter } from "@/utils/hooks/useScheduledGamesFilter";
import {
  playoffWeeksGroup,
  weekOptions,
  teamFilterOptions,
  sortOptions,
} from "./constants";
import { SelectField } from "./SelectField";
import styles from "./style.module.scss";

interface FilterProps {
  currentWeek?: string;
}

export default function Filter({ currentWeek }: FilterProps) {
  const [isPending, startTransition] = useTransition();
  const { logAmplitudeEvent } = useAmplitude();

  const router = useRouter();
  const filter = useScheduledGamesFilter();

  const navigateAction = (val: string) =>
    router.push(`/nfl/scores/week/${val}`);

  return (
    <div className={styles.container}>
      <SelectField
        label="Week"
        id="weekSelect"
        onValueChange={(val) => {
          logAmplitudeEvent(SCHEDULE_FILTER_APPLIED, {
            "Filter Name": "Week",
            Module: "schedule_filters",
            "Filter Value": `week_${val}`,
            Competition: "NFL",
            "Page Name": "schedule",
          });
          startTransition(() => navigateAction(val));
        }}
        defaultValue={currentWeek}
        options={weekOptions}
        optGroups={playoffWeeksGroup}
        loading={isPending}
      />
      <SelectField
        label="Teams"
        options={teamFilterOptions}
        defaultValue="all"
        id="teamSelect"
        onValueChange={(conf) => {
          logAmplitudeEvent(SCHEDULE_FILTER_APPLIED, {
            "Filter Name": "Conference",
            Module: "schedule_filters",
            "Filter Value": `conference_${conf}`,
            Competition: "NFL",
            "Page Name": "schedule",
          });
          filter?.onTeamFilterChange(conf);
        }}
      />
      <SelectField
        label="Sort"
        id="sortBy"
        defaultValue={"dateAsc"}
        options={sortOptions}
        onValueChange={(sort) => {
          logAmplitudeEvent(SCHEDULE_SORT_APPLIED, {
            Module: "schedule_filters",
            "Sort Name": sort,
            Competition: "NFL",
            "Page Name": "schedule",
          });
          filter?.onTeamSortChange(sort);
        }}
      />
    </div>
  );
}
